<template lang="pug">
section.wam-content.onboarding-dsp(:class="{'full-width': isLoading || zeroState }")

    //- Loading data
    template(v-if="isLoading || (zeroState && accountsDspsIsLoading)")
        spinner.l-flex-row--center.l-align-center(width="200" height="200")

    //- Zero state
    template(v-else-if="zeroState && !accountsDspsIsLoading")
        section.l-flex-column.is-empty.zero-state
            p.zero-state-message There is no DSP configuration set yet.
            button.btn.btn--round.btn-rev.btn--big(
                :class="{'ui-disabled': disabledDSPAction}"
                @click="newDsp()") Create a DSP configuration

    template(v-else-if="displayDsps")
        //- cclones list
        Panel(panelClassName="builder-cclone-list")
            template(slot="header")
                sectionHeader(title="Data partner")
                    template(slot="action")
                        div.section-header--action
                            div.section-header--action-item.action-item-direct.l-flex-row
                                button(
                                    class="btn-border btn--small btn--round l-flex-row l-align-center"
                                    @click="newDsp"
                                    :class="{'ui-disabled': disabledDSPAction || isLoading}"
                                )
                                    | New Partner
                                button.btn-search.btn-pale.btn--small.btn--round.l-flex-row.l-align-center(
                                    @click="resetDspSelection()"
                                    :class="{'ui-disabled': !filterActive}")
                                    | All configurations
            template(slot="content")
                ul.dsp-list.scrollbar.is-scrollable
                    li.dsp-item(
                        v-for="(dsp, key) of dspList"
                        v-if="dspConfigurationsCount(dsp.id) > 0"
                        :class="{'is-selected': selectedDsp === dsp.id}"
                        @click.stop="selectDsp(dsp.id)")
                        div.dsp-item-label {{ dsp.label }}
                        div.dsp-item-counter.counter {{ dspConfigurationsCount(dsp.id) }}

        template(v-if="dspIsLoading || (!zeroState && accountsDspsIsLoading)")
            spinner.l-flex-row--center.l-align-center(width="100" height="100")

        //- configurations list
        template(v-else-if="displayAccountsDsps")
            section.dsp-configuration.l-flex-column
                sectionHeader.section-header-dsp(title="Configurations")
                DspConfigurations(
                    :class="{'dsp-monitoring-is-loading': false}"
                    :configurations="configurations"
                )

            //- configuration details
            div.configuration-detail.no-data-selected(v-if="selectedDspConfigurationId === null" )
                p Select a configuration
                    br
                    | to see details

            Panel(panelClassName="configuration-detail" v-else-if="selectedDspConfigurationId !== null")
                template(slot="header")
                    sectionHeader(title="details")
                template(slot="content")
                    DspConfigurationDetails

    //- form
    template(v-if="displayFormModal")
        //- modal dsp form
        div.overlay-close(
            @click="closeModal()")
        div.modal(
            class="modal-h-full modal__medium modal-dsp")
            DspForm
    //- MODAL - Delete configuration
    template(v-if="displayConfirmationModal")
        div.overlay-close(@click="setDisplayModal({ item: 'confirmation', display: false })")
        div.modal.modal-h-auto.modal__small.modal-delete
            ConfirmationModal(modalClassName='modal-wrapper')
                template(slot='content')
                    div Are you sure you want to delete this configuration?
                    p
                        span.is-highlighted__danger {{ activeTransfers }}
                        span  transfer(s) will be deleted
                template(slot='footer')
                    div.footer-content.l-flex-row--between
                        button.btn.btn--medium.btn--round(@click="setDisplayModal({ item: 'confirmation', display: false })") Cancel
                        button.btn.btn--medium.btn--round.btn-rev.btn-delete(@click.once="deleteAccountDspAndTransfer()") Delete
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { get, groupBy, isNil, size, isEmpty } from 'lodash'

// common components
import Panel from '@/components/common/Panel'
import SectionHeader from '@/components/common/SectionHeader'
import ConfirmationModal from '@/components/common/confirmationModal'

// dsp configurations components
import DspConfigurations from '@/components/onBoarding/DspConfigurations'
import DspConfigurationDetails from '@/components/onBoarding/DspConfigurationDetails'

// form component
import DspForm from '@/components/onBoarding/DspForm'

export default {
    name: 'Partners',
    components: { ConfirmationModal, Panel, SectionHeader, DspConfigurations, DspConfigurationDetails, DspForm },

    beforeRouteLeave(_to, _from, next) {
        this.resetDspSelection()
        next()
    },
    watch: {
        // isCurrentDspEmpty: {
        //     handler: function(newValue) {
        //         // reset the selected DSP if it becomes empty
        //         if (newValue) {
        //             this.selectDsp(null)
        //         }
        //     },
        //     deep: true
        // },
        configurations: {
            handler: function(newValue) {
                // Display zero state if last configuration gets deleted
                if (isEmpty(newValue)) this.setZeroState({ zeroState: true })
            },
            deep: true
        }
    },

    computed: {
        // Call to state
        ...mapState('data/dsp', {
            dspList: state => state.list,
            dspIsLoading: state => state.isLoading
        }),
        ...mapState('data/accountsDsps', {
            accountsDspsList: state => state.list,
            accountsDspsIsLoading: state => state.isLoading
        }),
        ...mapState('ui/dsp', {
            displayModal: state => state.displayModal,
            selectedDsp: state => state.selectedDsp,
            selectedDspConfigurationId: state => state.selectedRowId,
            zeroState: state => state.zeroState,
            deletedConfigId: state => state.deletedConfigId
        }),
        ...mapState('ui/transfers', {
            activeTransfers: state => state.activeTransfers
        }),
        ...mapGetters('account', ['getAccessToDSP', 'getIsDSPActionAllowed']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        isLoading() {
            return !this.criteriaListIsReady && this.hasUserAccessToDSP
        },
        displayFormModal() {
            return this.displayModal.form
        },
        displayConfirmationModal() {
            return this.displayModal.confirmation
        },
        accountsDspGroupedByDsp() {
            return groupBy(this.accountsDspsList, 'dsp_id')
        },
        configurations() {
            return isNil(this.selectedDsp) ? this.accountsDspsList : get(this.accountsDspGroupedByDsp, this.selectedDsp, [])
        },
        filterActive() {
            return this.selectedDsp !== null
        },
        displayDsps() {
            return !(this.isLoading && this.zeroState) && this.hasUserAccessToDSP
        },
        displayAccountsDsps() {
            return !this.dspIsLoading && !this.accountsDspsIsLoading
        },
        hasUserAccessToDSP() {
            return this.getAccessToDSP()
        },
        disabledDSPAction() {
            return !this.getIsDSPActionAllowed()
        },
        isCurrentDspEmpty() {
            return this.dspConfigurationsCount(this.selectedDsp) < 1
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/dsp', ['setDisplayModal', 'setSelectedDsp', 'setSelectedRow', 'setZeroState']),
        ...mapActions('data/accountsDsps', ['deleteAccountsDsp']),
        ...mapActions('data/transfer', ['deleteAccountsDspActiveTransfers']),
        async deleteAccountDspAndTransfer() {
            await this.deleteAccountsDspActiveTransfers({ accounts_dsp_id: this.deletedConfigId }).then(async () => {
                await this.deleteAccountsDsp()
                this.resetDspSelection()
            })
        },
        closeModal() {
            this.setDisplayModal({ item: 'form', display: false })
        },
        dspConfigurationsCount(dspId) {
            return size(get(this.accountsDspGroupedByDsp, dspId, []))
        },
        newDsp() {
            this.setDisplayModal({ item: 'form', display: true })
        },
        selectDsp(dspId) {
            if (isNil(this.selectedDsp) || this.selectedDsp !== dspId) {
                this.setSelectedRow({ rowId: null })
                this.setSelectedDsp({ selectedDsp: dspId })
            } else {
                this.setSelectedDsp({ selectedDsp: null })
            }
        },
        resetDspSelection() {
            this.setSelectedRow({ rowId: null })
            this.setSelectedDsp({ selectedDsp: null })
        }
    }
}
</script>

<style lang="scss" scoped>
.section-header-dsp {
    margin-bottom: 16px;
}

.dsp-list {
    padding-right: 8px;
    max-height: calc(100vh - 220px);
}

.dsp-item {
    display: flex;
    justify-content: space-between;

    cursor: pointer;

    color: color('text');

    & + & {
        margin-top: 16px;
    }

    &:hover {
        color: color('text-active');
    }

    &.is-selected {
        color: color('accent');
    }
}
</style>
